import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CurrencyRubleRounded } from '@mui/icons-material';
import { Alert, Avatar, Box, CardContent, CardHeader, Skeleton, Typography, } from '@mui/material';
import { format_price_x100 } from 'console/billing/billing-utils';
import { BillingPayCard } from 'console/billing/widgets';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { BilledSimStatusLine } from 'console/sim/shared/sim-status';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { memo, useCallback, useEffect } from 'react';
import * as S from 'console/billing/styles';
import SimMts from 'console/images/sim/sim-mts.svg';
import { request_sim_prolong_info, setSimAutoProlong } from 'console/sim/redux/actions';
export const WithOutChangeTariff = memo(function WithOutChangeTariff(props) {
    const { billed_sim, sim_state } = props;
    const { loading, error, amount_x100 } = useAppSelector((state) => state.sim_dialogs.prolong_info);
    const onRequestProlongInfo = useAction(request_sim_prolong_info);
    const onAutoProlongSim = useAction(setSimAutoProlong);
    const getColor = useCallback((status) => status == 'ok' ? 'textSecondary' : status, []);
    useEffect(() => {
        if (billed_sim != null) {
            onRequestProlongInfo(billed_sim?.sim_card.id, 1);
        }
    }, [billed_sim]);
    if (billed_sim == null) {
        return null;
    }
    const onChangeAutoProlong = useCallback((auto_prolong) => {
        if (billed_sim) {
            onAutoProlongSim(billed_sim, auto_prolong);
        }
    }, [onAutoProlongSim, billed_sim]);
    return (_jsxs(_Fragment, { children: [_jsxs(S.Card, { variant: "outlined", sx: {
                    '& .MuiAvatar-root': {
                        backgroundColor: 'transparent',
                    },
                    '& .MuiCardHeader-avatar': {
                        mr: 1,
                    },
                }, children: [_jsx(CardHeader, { avatar: _jsx(Avatar, { children: _jsx(CustomIcon, { Icon: SimMts, fontSize: "1.5rem" }) }), title: "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u044B", titleTypographyProps: {
                            variant: 'h6',
                            color: 'textSecondary',
                        } }), _jsxs(CardContent, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            pt: 0,
                        }, children: [_jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, children: [sim_state && (_jsx(Typography, { variant: "subtitle1", color: getColor(sim_state.status), children: sim_state.text })), _jsx(BilledSimStatusLine, { sim: billed_sim })] }), _jsxs(Box, { children: [_jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C" }), error ? (_jsx(Alert, { severity: "error", children: error.error_ui })) : loading ? (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 20 })) : (_jsxs(Typography, { variant: "h6", color: "textPrimary", children: [format_price_x100(amount_x100 ?? 1000_00), "/\u043C\u0435\u0441"] }))] }), billed_sim && (_jsx(MaterialBoolControl, { value: billed_sim.auto_prolong, label: "\u0410\u0432\u0442\u043E\u043F\u043B\u0430\u0442\u0451\u0436 \u0441 \u0431\u0430\u043B\u0430\u043D\u0441\u0430", onChange: onChangeAutoProlong, color: "secondary", help_id: "sim_auto_prolong" }))] })] }), _jsx(BillingPayCard, { pay_props: {
                    price_x100: amount_x100 ?? 1000_00,
                    pay_intent: {
                        type: 'prolong_sim',
                        sim_id: billed_sim.sim_card.id,
                        msisdn: billed_sim.sim_card.msisdn,
                        months: 1,
                        timezone: -Math.floor(new Date().getTimezoneOffset() / 60),
                        tariff: billed_sim.tariff_state.current,
                    },
                    button_props: {
                        startIcon: _jsx(CurrencyRubleRounded, {}),
                    },
                } })] }));
});
